{
  "app": {
    "title": "Facturation",
    "close_button": "Fermer",
    "loading": "Chargement en cours..."
  },
  "orders_dashboard": {
    "title": "Commandes",
    "filter_all": "Toutes",
    "filter_unassigned": "Non attribué",
    "filter_expiring": "Expire bientôt",
    "filter_undeployed": "Disponible pour le déploiement",
    "filter_canActivate": "Disponible pour activation",
    "search_orders": "Rechercher les commandes"
  },
  "orders_list": {
    "subscriptionExpiry": "DATE D'EXPIRATION DE L'ABONNEMENT",
    "end_of_orders_list": "Fin de la liste des commandes",
    "orderDate": "DATE DE LA COMMANDE",
    "orderNumber": "NUMÉRO DE LA COMMANDE",
    "subscriptionNumber": "NUMÉRO DE L'ABONNEMENT",
    "accountName": "COMPTE AFFECTÉ",
    "unassigned": "Non attribué",
    "unavailable": "Non disponible",
    "expiring": "EXPIRE BIENTÔT",
    "assign": "AFFECTER",
    "expired": "EXPIRÉ",
    "perpetual": "PERMANENT",
    "pending": "ACTIVATION EN ATTENTE",
    "error_retrieving_orders": "Une erreur s'est produite lors de la récupération des commandes.",
    "no_orders_found": "Aucune commande trouvée.",
    "deploy": "Déployer",
    "activate": "Activer"
  },
  "order_details": {
    "deploy_button": "Déployer",
    "activate_button": "Activer",
    "assign_button": "Affecter",
    "order_number": "Commande #",
    "tracking_number": "Numéro de Suivi",
    "subscription_number": "Abonnement Numéro",
    "see_additional_details": "Voir les détails de suivi supplémentaire",
    "hide_additional_details": "Réduire les détails de suivi supplémentaire",
    "po_number": "Numéro de bon de commande",
    "reseller_SAP_Id": "ID SAP du Revendeur",
    "sapOrderId": "ID de la Commande SAP",
    "order_assigned_to": "Commande attribuée à",
    "start_date": "Date de début",
    "term": "Terme",
    "please_pick_acct_msg": "Nous n'avons pas été en mesure de faire correspondre cette commande alors veuillez sélectionner manuellement un compte pour l'appliquer.",
    "company": "Entreprise",
    "create_new_account": "Créez un nouveau compte",
    "order_expiry_time": "LA COMMANDE EXPIRE EN {{numdays}} JOURS",
    "licenses": "Licences",
    "license": "Licence",
    "customerSapId": "ID SAP client",
    "customerPONumber": "Numéro du bon de commande client",
    "search_companies": "Sociétés de recherche",
    "month": "Mois",
    "year": "Année",
    "day": "Jour",
    "unknown": "Inconnu",
    "assigning_account_to_order": "Affectation de la commande au Compte...",
    "deploying_order": "Commande en cours de déploiement...",
    "activating_order": "Activation de la commande en cours...",
    "error_assigning_order": "Une erreur s'est produit lors de l'affectation de la commande au compte.",
    "error_deploying_order": "Il y a eu une erreur lors du déploiement de la commande.",
    "error_activating_order": "Il y a eu une erreur lors de l'activation de la commande.",
    "cannot_comm_parent": "Nous ne pouvons pas vous rediriger vers le formulaire approprié, vous pouvez créer un compte à partir de l'application Comptes.",
    "no_results_found": "Aucun résultat trouvé",
    "existing-subscription": "L'assignation a échoué : cette entreprise a déjà une commande.",
    "0001": "Licences insuffisantes. Le nombre de licences gratuites attribuées ({free}) dépasse le nombre de licences ({paid}) dans la commande payante.",
    "restricted_view_warning": "Fonctionnalités désactivées. Votre accès est restreint."
  },
  "order_complete": {
    "go-to-account-integrations": "Aller aux options d'intégrations de compte",
    "go-to-account": "Aller au compte",
    "activate-order": "Activer la commande",
    "order-added": "Commandes ajoutées!",
    "order-deployed": "Commande déployée!",
    "order-activated": "Commande activée!",
    "enable-integration": " Remarque: les éléments de cette commande nécessitent une configuration ainsi qu'une activation de l'intégration pour être utilisés.",
    "activate-order-instructions": "Juste une note, cette commande doit être activée pour fonctionner."
  },
  "errors": {
    "504-general-message": "La solution est occupée ou inaccessible. Veuillez réessayer.",
    "couldnt-find-order": "Nous n'avons pas trouvé la commande dans la liste. Veuillez recharger la page."
  }
}